import React, { useEffect, useState } from "react";
import "./CommingSoon.css";

const CommingSoon = () => {
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const launchDate = new Date("Apr 30, 2026 00:00:00").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const diff = launchDate - now;

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft({ days, hours, minutes, seconds });

      if (diff < 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="cs-coming-container">
      <div className="cs-coming-box">
        <h1>🚀 Coming Soon</h1>
        <p>We are working hard to launch something amazing!</p>

        <div className="cs-countdown">
          <div>
            <span>{timeLeft.days || "00"}</span>
            <small>Days</small>
          </div>
          <div>
            <span>{timeLeft.hours || "00"}</span>
            <small>Hours</small>
          </div>
          <div>
            <span>{timeLeft.minutes || "00"}</span>
            <small>Minutes</small>
          </div>
          <div>
            <span>{timeLeft.seconds || "00"}</span>
            <small>Seconds</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommingSoon;